// Mitigation B: persistent per-user marker indicating signupUser() has run
// successfully for this Supabase user on this device. Used by AuthContext's
// recovery effect to avoid re-firing /api/user/signup once any of the three
// signup paths (AuthCallbackPage, OtpModal, recovery) has already handled
// this user.
//
// Storage uses localStorage so a successful signupUser in one tab/session
// silences the recovery in subsequent tabs/sessions on the same device.
// All access is wrapped in try/catch — if storage is unavailable (private
// mode, quota), recovery just runs again next mount; backend RPC is
// idempotent so this is safe.

const SIGNUP_RECOVERED_PREFIX = 'genanything_signup_recovered_';

function key(userId: string): string {
  return SIGNUP_RECOVERED_PREFIX + userId;
}

export function isSignupRecoveryDone(userId: string): boolean {
  try {
    return !!localStorage.getItem(key(userId));
  } catch {
    return false;
  }
}

export function markSignupRecoveryDone(userId: string): void {
  try {
    localStorage.setItem(key(userId), '1');
  } catch {
    // ignore — storage unavailable; next mount will retry, backend is idempotent
  }
}
